import React from 'react';
import { Button, Modal } from 'antd';
import { LightningIcon } from '@phosphor-icons/react';

export interface DashboardPredictIdealLayoutModalProps {
    theme: string;
    open: boolean;
    onClose: () => void;
    idealLayoutLoading: boolean;
    layoutProductionByKey: Record<string, number> | null | undefined;
    handlePredictIdealLayout: () => void;
    idealLayoutRecommendation: string | null | undefined;
}

export function DashboardPredictIdealLayoutModal({
    theme,
    open,
    onClose,
    idealLayoutLoading,
    layoutProductionByKey,
    handlePredictIdealLayout,
    idealLayoutRecommendation,
}: DashboardPredictIdealLayoutModalProps) {
    return (
        <Modal
            title={
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                    <LightningIcon size={20} weight="duotone" /> Predict ideal layout
                </span>
            }
            open={open}
            onCancel={onClose}
            footer={null}
            width={520}
            className={`obd-theme-${theme}`}
            rootClassName={`obd-form-controls-modal-root obd-theme-${theme}`}
            destroyOnHidden
        >
            <div style={{ padding: '4px 0' }}>
                <p
                    style={{
                        fontSize: 13,
                        color: theme === 'dark' ? 'rgba(203,213,225,0.95)' : '#475569',
                        marginBottom: 14,
                    }}
                >
                    Send layout options (production and modules) to AI and get a recommended layout. Run AI first to
                    generate at least 2 layout options.
                </p>
                <Button
                    size="small"
                    type="primary"
                    loading={idealLayoutLoading}
                    disabled={idealLayoutLoading || Object.keys(layoutProductionByKey || {}).length < 2}
                    onClick={() => {
                        handlePredictIdealLayout();
                    }}
                >
                    {idealLayoutLoading ? 'Asking AI…' : 'Predict ideal layout'}
                </Button>
                {idealLayoutRecommendation != null && idealLayoutRecommendation !== '' && (
                    <div
                        style={{
                            marginTop: 14,
                            padding: 14,
                            borderRadius: 10,
                            background: theme === 'dark' ? 'rgba(15,23,42,0.8)' : '#f8fafc',
                            border: `1px solid ${theme === 'dark' ? 'rgba(55,65,81,0.6)' : '#e2e8f0'}`,
                            whiteSpace: 'pre-wrap',
                            fontSize: 13,
                            color: theme === 'dark' ? 'rgba(226,232,240,0.96)' : '#1e293b',
                        }}
                    >
                        {idealLayoutRecommendation}
                    </div>
                )}
            </div>
        </Modal>
    );
}
